<div [ngClass]="{ completed: task.completed, selected: isSelected, 'has-accent': showShowName && task.show?.primaryColor }"
  class="task-card"
  [style.--accent-color]="task.show?.primaryColor">

  <div class="checkbox">
    @if (viewCheckbox) {
      <ion-checkbox
        (ionChange)="toggleTask($event, task)"
        [checked]="!!task.completed"
        [disabled]="task.completed"
        data-cy="task-checkbox"
        />
    }
  </div>

  <div (click)="navigateToTaskDetails()" style="width:100%;">
    <div class="task-details-container">

      <div class="task-details">

        <!-- Show name (only when multiple shows are filtered) -->
        @if (showShowName && task.show?.name) {
          <div class="show-name">
            {{ task.show.name }}
          </div>
        }

        @if (showPriorities && task.priority !== Priority.Medium) {
          <div class="tags">
            <ion-badge [color]="getPriorityColor(task.priority)">{{ getPriorityString(task.priority) }}</ion-badge>
          </div>
        }

        <div class="title">
          @if (!viewCheckbox) {
            <span>- </span>
          }
          {{ task.title }}
        </div>

        @if (task.description?.trim().length > 0) {
          <div class="description">
            {{ getTruncatedDescription() }}
          </div>
        }



        @if (viewCreationDate) {
          <div class="createdAt">
            Toegevoegd op {{ task.createdAt | date:'d MMMM y':'CEST':'nl-NL' }}
            @if (task.completed) {
              <span><br>Afgevinkt op {{ task.completedDateTime | date:'d MMMM y':'CEST':'nl-NL' }}</span>
            }
          </div>
        }

        @if (task.images?.length > 0 || task.comments.length > 0) {
          <div class="task-markers">
            @if (task.images?.length > 0) {
              <span class="task-marker task-marker--images">
                <ion-icon name="camera-outline" />
                {{ task.images?.length }}
              </span>
            }
            @if (task.comments.length > 0) {
              <span class="task-marker task-marker--comments" [class.has-new]="hasNewComments">
                <ion-icon name="chatbubble-ellipses-outline" />
                {{ task.comments.length }}
                @if (hasNewComments) {
                  <span class="new-dot" aria-label="nieuwe reacties"></span>
                }
              </span>
            }
          </div>
        }

        </div>

        <div class="chevron">
          <ion-icon name="chevron-forward-outline" />
        </div>

      </div>
    </div>

  </div>


